import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import type { Role } from '@/types/auth'
import type { ReactNode } from 'react'
import { PermissionDenied } from '@/components/common/PermissionDenied'

interface Props {
  children: ReactNode
  roles?: Role[]
}

export function RequireAuth({ children, roles }: Props) {
  const { user, loading, hasRole } = useAuth()
  const location = useLocation()

  if (loading) {
    return (
      <div className="flex h-dvh items-center justify-center" aria-busy="true" aria-label="Signing in">
        <span className="size-5 animate-spin rounded-full border-2 border-primary border-r-transparent" />
      </div>
    )
  }
  if (!user) {
    // Keep the query string and hash too, so a deep link (e.g. /payroll/:id?tab=lop) survives sign-in.
    return <Navigate to="/login" state={{ from: location.pathname + location.search + location.hash }} replace />
  }
  if (roles && !hasRole(roles)) {
    // Rendered inside the shell with a way out; never names roles (contract defect #11).
    return <PermissionDenied />
  }
  return <>{children}</>
}
